var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order_action" },
    [
      _c("b-overlay", { attrs: { is_show: _vm.is_load } }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _vm._l(_vm.o_states, function (state) {
              return _c(
                "button",
                {
                  staticClass:
                    "btn btn-lg waves-effect waves-themed w-100 mb-3",
                  class: _vm.get_butt_class(state.action),
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.set_state(state.action)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "fal fa-check mr-1" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t(state.human)) +
                      "\n            "
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "adm_action mt-5" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-lg waves-effect waves-themed w-100 mb-3 btn-danger",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.set_state("hide_active")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.__t("FORCE_MOVE_FINISH_STATE")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }